(() => {
  try {
    document.querySelectorAll('[href^="#tooltip"]').forEach((tooltip) => {
      const content = decodeURI(document.querySelector('[href^="#tooltip"]').href.split('#tooltip=')[1]);
      
      tippy(tooltip, {
        maxWidth: 280,
        content: content
      });
    });
  } catch (error) {
    console.log(error);
  }

  function showCanadaPromotionPopup() {
    const lastShownTime = localStorage.getItem('canadaPopupShown');
    if (!lastShownTime || (Date.now() - parseInt(lastShownTime)) > (30 * 60 * 1000)) {
      document.body.classList.add('canada-popup-opened');
    }
  }

  function hideCanadaPromotionPopup() {
    document.body.classList.remove('canada-popup-opened');
    localStorage.setItem('canadaPopupShown', Date.now());
  }

  function showContactSupportPopup() {
    const lastShownTime = localStorage.getItem('contactSupportShown');
    if (!lastShownTime || (Date.now() - parseInt(lastShownTime)) > (60 * 60 * 1000)) {
      document.body.classList.add('contact-support__modal-opened');
    }
  }

  function hideContactSupportPopup() {
    document.body.classList.remove('contact-support__modal-opened');
    localStorage.setItem('contactSupportShown', Date.now());
  }

  // Function to hide content if user is outside the United States
  async function checkLocation() {
    try {
      // Fetch IP address
      const response = await fetch('https://ipinfo.io/json');
      const data = await response.json();
      const ipAddress = data.ip;
  
      // Fetch country info
      const countryResponse = await fetch(`https://ipinfo.io/${ipAddress}/country`);
      const countryData = await countryResponse.text();

      const canadaPopup = document.querySelector('.canada-promo-popup');
      if (canadaPopup && countryData.trim() === 'CA') showCanadaPromotionPopup();

      const contactSupportPopup = document.querySelector('.contact-support__modal');
      const enableContactSupportPopup = (countryData.trim() === 'CA' || countryData.trim() === 'US' ) ? false : true;
      if (contactSupportPopup && enableContactSupportPopup) showContactSupportPopup();

      const shippingWarnings = document.querySelectorAll('.shipping-alert-warning');
      
      // Check if user is outside the United States
      if (shippingWarnings.length) {
        const showWarningMessage = Array.from(shippingWarnings).every((shippingWarning) => shippingWarning.dataset.country !== countryData.trim());
        
        if (showWarningMessage) {
          const productFormButtons = document.querySelector('.product-buy-buttons');
          if (productFormButtons) productFormButtons.style.display = 'none';
    
          const subscriptionWidget = document.querySelector('.subscription-widget-cst');
          if (subscriptionWidget) subscriptionWidget.style.display = 'none';
    
          const quantitySelector = document.querySelector('.product-form__quantity');
          if (quantitySelector) quantitySelector.style.display = 'none';
    
          // Show shipping alert warning
          if (shippingWarnings.length > 1) {
            shippingWarnings.forEach((shippingWarning) => {
              if (shippingWarning.dataset.country == 'US') shippingWarning.style.display = 'block';
            });
          } else {
            shippingWarnings[0].style.display = 'block';
          }
    
          // Add event listener to confirm-us-address link
          const confirmUsAddressLink = document.querySelector('.confirm-us-address');
          confirmUsAddressLink?.addEventListener('click', function(event) {
            event.preventDefault();
            
            shippingWarnings.forEach((shippingWarning) => { shippingWarning.style.display = 'none' });
            
            if (productFormButtons) productFormButtons.style.display = 'block';
            if (subscriptionWidget) subscriptionWidget.style.display = 'block';
            if (quantitySelector) quantitySelector.style.display = 'flex';
          });
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  checkLocation();

  const canadaPopupClose = document.querySelector('.canada-promo-popup__close');
  canadaPopupClose?.addEventListener('click', () => { hideCanadaPromotionPopup() });

  const canadaPopupShopButton = document.querySelector('.canada-promo-popup__shop-button');
  canadaPopupShopButton?.addEventListener('click', () => { hideCanadaPromotionPopup() });

  const contactSupportModalClose = document.querySelector('.contact-support__modal-close');
  contactSupportModalClose?.addEventListener('click', () => { hideContactSupportPopup() });
  
  const menuDrawerToggle = document.querySelector('.header__icon--menu');
  menuDrawerToggle?.addEventListener('click', () => {
    document.body.classList.add('menu-drawer-opened');
  });
  
  const menuDrawerClose = document.querySelector('.menu-drawer__close');
  menuDrawerClose?.addEventListener('click', () => {
    document.body.classList.remove('menu-drawer-opened');
  });

  const menuDrawerMask = document.querySelector('.menu-drawer__mask');
  menuDrawerMask?.addEventListener('click', () => {
    document.body.classList.remove('menu-drawer-opened');
  });
    
  const slideshows = document.querySelectorAll('.slideshow__slider');
  slideshows.forEach((slideshow) => {
    const slider = new Swiper( slideshow, {
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
    });
  });

  const testimonials = document.querySelectorAll('.testimonials__slider-wrapper');
  testimonials.forEach((testimonial) => {
    const sliderEl = testimonial.querySelector('.testimonials__slider');
    const prevEl = testimonial.querySelector('.swiper-button-prev')
    const nextEl = testimonial.querySelector('.swiper-button-next');
    
    const slider = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  });

  const reviewSliderNextEl = document.querySelector('.reivew-slider-next');
  const reviewSliderPrevEl = document.querySelector('.reivew-slider-prev');

  const reviewSlider = new Swiper('.reivew-slider' , {
    slidesPerView: 'auto',
    loop: true,
    navigation: {
      nextEl: reviewSliderNextEl,
      prevEl: reviewSliderPrevEl,
    },
  });
  
  function collapseAccordion(accordion) {
    const accordionContent = accordion.nextElementSibling;
    
    accordion.classList.remove('active');
    accordionContent.classList.remove('active');
    accordionContent.style.height = '0px';
  }
  
  const accordions = document.querySelectorAll('.faq__accordion-title');
  accordions.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const accordionContent = accordion.nextElementSibling;
      const accordionContentHeight = accordionContent.querySelector('.faq__accordion-content-inner').offsetHeight;
      
      if (accordion.classList.contains('active')) {
        collapseAccordion(accordion);
      } else {
        accordions.forEach((accordion2) => { if (accordion2.classList.contains('active')) collapseAccordion(accordion2) });
        
        accordion.classList.add('active');
        accordionContent.classList.add('active');
        accordionContent.style.height = accordionContentHeight + 'px';
      }
    });
  });

  const wizardSections = document.querySelectorAll('.wizard__steps');
  wizardSections.forEach((section) => {
    const wizardTabs = section.querySelectorAll('.wizard__steps-tab');
    const wizardTabsContent = section.querySelectorAll('.wizard__step-content');
    
    wizardTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        wizardTabs.forEach((tab2) => { tab2.classList.remove('active') });
        wizardTabsContent.forEach((tabContent) => { tabContent.classList.remove('active') });
        
        tab.classList.add('active');
        document.getElementById(`WizardStep-${tab.dataset.id}`).classList.add('active');
      });
    });

    const wizardNavigations = section.querySelectorAll('.wizard__step-button');
    wizardNavigations.forEach((button) => {
      button.addEventListener('click', () => {
        wizardTabs.forEach((tab) => { if (tab.dataset.index == button.dataset.tabIndex) tab.click() });
      });
    });
  });

  const scrollTopButtons = document.querySelectorAll('.button--scroll-top');
  scrollTopButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      window.scroll({ top: 0, behavior: 'smooth' });
    });
  });

  const mediaTabs = document.querySelectorAll('.main-media-tab');
  const mediaTabsContent = document.querySelectorAll('.main-media-tab--content');

  mediaTabs.forEach((mediaTab) => {
    mediaTab.addEventListener('click', (event) => {
      event.preventDefault();

      mediaTabs.forEach((mediaTab2) => { mediaTab2.classList.remove('active') });
      mediaTab.classList.add('active');

      mediaTabsContent.forEach((mediaTabContent) => { mediaTabContent.classList.add('hidden') });
      document.getElementById(mediaTab.dataset.id).classList.remove('hidden');
    });
  });

  const videoModal = document.getElementById('VideoModal');
  const videoModalIframe = document.getElementById('VideoModalIframe');
  const videoModalVideo = document.getElementById('VideoModalVideo');
  
  videoModal?.addEventListener('click', (event) => {
    document.body.classList.remove('video-modal-opened');

    videoModal.querySelector('.iframe-wrapper').classList.add('hidden');
    videoModalIframe.src = '';

    videoModalVideo.src = '';
    VideoModalVideo.classList.add('hidden');
  });

  videoModalVideo?.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  const embedLinks = document.querySelectorAll('a[href]');
  
  embedLinks.forEach((embedLink) => {
    if (embedLink.href.includes('www.youtube.com/embed') || embedLink.href.includes('.mp4')) {
      embedLink.addEventListener('click', (event) => {
        event.preventDefault();
  
        if (embedLink.href.includes('www.youtube.com/embed')) {
          document.body.classList.add('video-modal-opened');
          videoModal.querySelector('.iframe-wrapper').classList.remove('hidden');
          videoModalIframe.src = embedLink.href;
        }
  
        if (embedLink.href.includes('.mp4')) {
          document.body.classList.add('video-modal-opened');
          VideoModalVideo.classList.remove('hidden');
          VideoModalVideo.src = embedLink.href;
        }
      });
    }
  });
})();

function isMobile() {
  const minWidth = 768; // Minimum width for desktop devices
  return window.innerWidth < minWidth || screen.width < minWidth;
}

$(document).ready(function(){
if(isMobile()){
  //alert("Mobile device");
  $("#shopify-section-template--24432768188733__slideshow_cbjEbq").css("display","none");
  $(".slideshow__text__buttons").css("bottom","60%");
  $(".slideshow__text__buttons").css("left","1%");
}
else{
  //alert("Not mobile device");
  $("#shopify-section-template--24432768188733__slideshow_zkmDti").css("display","none");
}
});